'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHubSettingsAvatar = getHubSettingsAvatar;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _CryptoJS = require('CryptoJS');

var _CryptoJS2 = _interopRequireDefault(_CryptoJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAvatar = 'https://static.hsappstatic.net/salesImages/static-1.270/avatars/default-avatar.png';

function getHubSettingsAvatar(email) {
  if (!email) {
    return defaultAvatar;
  }

  var env = _enviro2.default.getInternal('api') === 'qa' ? 'qa' : '';
  var emailHash = _CryptoJS2.default.MD5(email.toLowerCase());

  return 'https://app.hubspot' + env + '.com/hubsettings/v1/avatar/hash/' + emailHash + '/100';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/avatar.js
// module id = 523
// module chunks = 0